import analytics from 'product-analytics'
import { useEffect } from 'react'
import { TrackingCookieType } from './types'

function useAnalytics(status: TrackingCookieType | undefined) {
  useEffect(() => {
    if (status === 'accepted') {
      return analytics.optIn()
    }
    if (status === 'rejected') {
      return analytics.optOut()
    }
    return analytics.optInOutPending()
  }, [status])

  useEffect(() => {
    return () => {
      analytics.cancel()
    }
  }, [])
}

export default useAnalytics
